import { render, staticRenderFns } from "./RecordedMultipleDeletionDialog.vue?vue&type=template&id=3badec68&"
import script from "./RecordedMultipleDeletionDialog.vue?vue&type=script&lang=ts&"
export * from "./RecordedMultipleDeletionDialog.vue?vue&type=script&lang=ts&"
import style0 from "./RecordedMultipleDeletionDialog.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports